import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["steps", "columns", "forceUpdate", "grid"];
import { useLatest } from '@ant-design/pro-utils';
import React, { useCallback, useMemo } from 'react';
import BetaSchemaForm from '../index';
import { StepsForm as ProStepsForm } from '../../../layouts/StepsForm';

var StepsForm = function StepsForm(_ref) {
  var steps = _ref.steps,
      columns = _ref.columns,
      forceUpdate = _ref.forceUpdate,
      grid = _ref.grid,
      props = _objectWithoutProperties(_ref, _excluded);

  var propsRef = useLatest(props);
  /**
   * Fixed StepsForm toggle step causing formRef to update
   */

  var onCurrentChange = useCallback(function (current) {
    var _propsRef$current$onC, _propsRef$current;

    (_propsRef$current$onC = (_propsRef$current = propsRef.current).onCurrentChange) === null || _propsRef$current$onC === void 0 ? void 0 : _propsRef$current$onC.call(_propsRef$current, current);
    forceUpdate([]);
  }, [forceUpdate, propsRef]);
  var StepDoms = useMemo(function () {
    return steps === null || steps === void 0 ? void 0 : steps.map(function (step, index) {
      return /*#__PURE__*/React.createElement(BetaSchemaForm, _extends({
        grid: grid
      }, step, {
        // eslint-disable-next-line react/no-array-index-key
        key: index,
        layoutType: "StepForm",
        columns: columns[index]
      }));
    });
  }, [columns, grid, steps]);
  return /*#__PURE__*/React.createElement(ProStepsForm, _extends({}, props, {
    onCurrentChange: onCurrentChange
  }), StepDoms);
};

export default StepsForm;